import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 同步合作商品价格
 * @param {Object} data 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function syncPartnerGoodsPrice(data) {
  return new Promise((resolve, reject) => {
    data.shopId = getShopId()
    request({
      url: '/partner.syncPartnerGoodsPrice',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}